/**
 * @file Constants used for overview feature
 * @author Max van Loosbroek
 */

import { HardwareType, OverviewColumn, OverviewFilter, RelationTeamLeaderType, RelationType, SummarySubscription } from './types/types'

export const OVERVIEW_COLUMNS: OverviewColumn[] = [
  {
    key: 'relation',
    headerName: 'relation',
    width: 240
  },
  {
    key: 'subRef',
    headerName: 'sub. ref.',
    width: 120
  },
  {
    key: 'boxNr',
    headerName: 'box nr.',
    width: 120,
    fontFamily: 'Roboto-Mono-Light'
  },
  {
    key: 'serial',
    headerName: 'serial',
    width: 178
  },
  {
    key: 'hardwareType',
    headerName: 'type',
    width: 150,
    canHide: true
  },
  {
    key: 'startAt',
    headerName: 'start date',
    width: 120,
    canHide: true
  },
  {
    key: 'endAt',
    headerName: 'end date',
    width: 120,
    canHide: true
  },
  {
    key: 'length',
    headerName: 'length',
    width: 85,
    canHide: true
  },
  {
    key: 'robotPaymentReference',
    headerName: 'r. pay ref.',
    width: 150,
    canHide: true
  },
  {
    key: 'subscriptionPaymentReference',
    headerName: 's. pay ref.',
    width: 150,
    canHide: true
  },
  {
    key: 'iccId',
    headerName: 'ICC id',
    width: 200,
    fontFamily: 'Roboto-Mono-Light',
    canHide: true
  },
  {
    key: 'clientId',
    headerName: 'client id',
    width: 150,
    fontFamily: 'Roboto-Mono-Light',
    canHide: true
  },
  {
    key: 'teamId',
    headerName: 'team id',
    width: 150,
    fontFamily: 'Roboto-Mono-Light',
    canHide: true
  },
  {
    key: 'subNotes',
    headerName: 'sub. notes',
    fontFamily: 'Roboto-Mono-Light',
    width: 600,
    canHide: true
  },
  {
    key: 'robotNotes',
    headerName: 't. notes',
    fontFamily: 'Roboto-Mono-Light',
    width: 600,
    canHide: true
  }
]

export const OVERVIEW_FILTERS: OverviewFilter[] = [
  {
    label: 'All',
    filterType: 'status',
    filterTerm: 'robotRelation'
  },
  {
    label: 'Valid',
    filterType: 'status',
    filterTerm: 'valid'
  },
  {
    label: 'Expiring',
    filterType: 'status',
    filterTerm: 'expiring'
  },
  {
    label: 'Expired',
    filterType: 'status',
    filterTerm: 'expired'
  },
  {
    label: 'Canceled',
    filterType: 'status',
    filterTerm: 'canceled'
  }
]

export const EMPTY_SUB = (
  latest: SummarySubscription,
  tempId: number
): SummarySubscription => ({
  id: tempId, // temporary id to distinguish temp sub from actual sub
  subscriptionLength: null,
  chainId: latest.chainId,
  parentId: latest.id,
  paymentReference: '',
  startAt: latest.endAt,
  endAt: '',
  notes: '',
  shippedAt: latest.shippedAt,
  relation: { ...latest.relation },
  hardwareType: latest.hardwareType,
  dashboardRobot: null
})

export const HardwareTypesWithLabels: Array<{displayName: string, value: HardwareType}> = [{ displayName: 'Tessa Voice', value: 'ROBOT' }, { displayName: 'Tessa Screen', value: 'VOICE_ASSISTANT' }]

export const HardwareTypes = HardwareTypesWithLabels.map((h) => h.value)

export const HardwareTypeLabels = HardwareTypesWithLabels.map((h) => h.displayName)

export const RelationTeamLeaderTypes: RelationTeamLeaderType[] = ['company', 'person']

export const RelationTypes: RelationType[] = ['Customer', 'Supplier', 'Partner']
